import React from 'react';
import './LoadingSpinner.scss';

const Spinner = ({ className }: { className?: string }) => (
  <div className={`loading-spinner ${className}`}></div>
);

export default Spinner;
